import React, { useEffect, useRef, useState } from "react";

// import styles from "../../../OtpVerification/OtpVerification.module.scss"
import styles from "../DisLoginOTPVerification/DisLoginOtp.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "@/lib/toast";
// import BackArrowIcon from "../../components/SVGComponents/BackArrowIcon";
import {
  combineClasses,
  getInitialValues,
  getItem,
  isCookiePresent,
  onlyNumbersInput,
  saveToken,
  setItem,
} from "@/lib/utils";
import Button from "@/components/Button/Button";
import routes from "@/routes/routes";
import AuthService from "@/services/api/auth/auth";
import Cookies from "js-cookie";
import formRenderer from "@/lib/formRenderer";
import { useForm } from "react-hook-form";
import DisRoutes from "@/routes/DisRoutes";
import { useRole } from "@/pages/Role/Role";
import { isValid } from "date-fns";

const otpLength = 4;

interface LocationState {
  email?: string;
}

interface VerifyOtpResponse {
  success?: boolean;
  message?: string;
}

const DisLoginOtpVerification: React.FC = () => {
  const [otp, setOtp] = useState<string[]>(Array(otpLength).fill(""));
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || getItem("otpEmail");
  // const email: any = (location.state as LocationState)?.email;
  const webAppData = getItem("layoutConfig");
  const refArray: any = useRef<HTMLInputElement[]>([]);
  const { role: contextRole } = useRole();
  const { role: paramRole } = useParams<{ role: string }>();
  const role = contextRole || paramRole;
  const [timer, setTimer] = useState(0);

  // const getDefaultRouteForRole = (role: string) => {
  //   const privateRoutes = DisRoutes.privateRoutes;
  //   const roleRoute = Object.values(privateRoutes).find(r =>
  //     r.roles?.includes(role)
  //   );
  //   return roleRoute ? `/${role}/${roleRoute.path}` : "/";
  // };

  // // After login success
  // navigate(getDefaultRouteForRole(role));

  const formConfig = {
    otp: {
      controlType: "input",
      label: "Enter OTP",
      placeholder: "Enter 4-digit OTP",
      isRequired: true,
      validations: {
        required: "OTP is required",
        minLength: { value: 4, message: "OTP must be 4 digits" },
        maxLength: { value: 4, message: "OTP must be 4 digits" },
        pattern: { value: /^[0-9]{4}$/, message: "Only digits allowed" },
      },
      props: {
        maxLength: 4,
        inputMode: "numeric",
        onInput: (e: any) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, "");
        },
        onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => {
          const pasted = e.clipboardData.getData("text").trim();
          if (/^\d{4}$/.test(pasted)) {
            setValue("otp", pasted, {
              shouldValidate: true,
              shouldDirty: true,
              shouldTouch: true,
            });
            e.preventDefault();
          }
        },
      },
    },
  };
  const {
    register,
    handleSubmit: submitForm,
    control,
    watch,
    setValue,
    formState,
  } = useForm({
    defaultValues: getInitialValues(formConfig),
    mode: "onChange",
  });

  const { isSubmitting , isValid} = formState;

  useEffect(() => {
    if (refArray.current.length === 0) {
      refArray.current = Array(otpLength)
        .fill(null)
        .map(() => null as unknown as HTMLInputElement);
    }
    setTimeout(() => {
      refArray.current[0]?.focus();
    }, 0);
  }, []);

  const onSubmit = async (values: any): Promise<void> => {
    //  e.preventDefault();
    // const otpString = otp.join("");
    // if (otpString.length < otpLength) return;
    try {
      const otpString = values.otp; // <-- final OTP value

      if (otpString.length !== 4) {
        toast.error("Please enter 4-digit OTP");
        return;
      }
    
      const storedEmail = getItem("otpEmail");
      const email = location.state?.email || storedEmail;

      const res: any = await AuthService.DisValLoginOtp({
        emailOrMobileNo: email ?? "",
        otp: otpString,
      });

      if (res?.status === 200) {
        toast.success("EmailId verified successfully");
        if (!isCookiePresent("currentUser")) {
          var exDate = new Date();
          exDate.setDate(exDate.getDate() + 7);
          // setItem("Permissions", res.Permissions);
          let currentUser = {
            userId: res.userId,
            // CompanyDetail: res.CompanyDetail,
            // roles: res.roles,
            accessToken: getItem("referraltoken"),
            userDetail: res.userDetail,
          };
          Cookies.set("currentUser", JSON.stringify(currentUser), {
            expires: exDate,
            path: "/",
          });
        }
        const token = res?.data.token;
        const username = res?.data.name;
        const distributorId = res?.data.id;
        const currency = res?.data?.currency;
        const retailerDistributorId = res.data.distributorId;
        const distributorName = res.data.distributorName;

        if (role === "retailer") {
          setItem("disretailerId", retailerDistributorId);
          setItem("distributorName", distributorName);
        } else {
          setItem("distributorId", distributorId);
        }

        saveToken("referraltoken", token);
        setItem("username", username);
        setItem("currency", currency);
       
        navigate(
          role === "distributor"
            ? `/${role}/${DisRoutes.privateRoutes?.RETAILER?.path}`
            : `/${role}/${DisRoutes.privateRoutes?.RetailerPurchase?.path}` ,
        );
      } else if (res.status === 417 || res.message === "Expectation Failed") {
        toast.error(res?.error);
      }
    } catch (err: any) {
      toast.error(err?.message || "OTP verification failed.");
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const index = parseInt(name, 10);

    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // shift focus
    if (value && index < otpLength - 1) {
      refArray.current[index + 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData("text").trim();
    if (/^\d{4,6}$/.test(pasted)) {
      // OTP length
      setOtp(pasted.split("").slice(0, otpLength));
      e.preventDefault();
    }
  };

  useEffect(() => {
    setTimer(30);
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const resendTime = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(resendTime);
    }
  }, [timer]);

  const verifyOtp = async (data: any) => {
    if (timer > 0) return;
    try {
      const otpString = data.otp;

      if (otpString.length !== 4) {
        toast.error("Please enter 4-digit OTP");
        return;
      }

      const res = await AuthService.DisValLoginOtp({
        emailOrMobileNo: email ?? "",
        otp: otpString,
      });

      if (res?.message === "Success") {
        toast.success("OTP verified successfully");
        const token = "Bearer " + res.data;
        if (!isCookiePresent("currentUser")) {
          var exDate = new Date();
          exDate.setDate(exDate.getDate() + 7);
          // setItem("Permissions", res.Permissions);
          let currentUser = {
            // userId: res.userId,
            // CompanyDetail: res.CompanyDetail,
            // roles: res.roles,
            accessToken: getItem("referraltoken"),
            // userDetail: res.userDetail,
          };
          Cookies.set("currentUser", JSON.stringify(currentUser), {
            expires: exDate,
            path: "/",
          });
        }
        saveToken("referraltoken", token);
        // saveToken("referraltoken", res.referralToken);
        navigate(DisRoutes?.privateRoutes?.Supplier?.path ?? "/");
      } else {
        toast.error(res?.message || "Invalid OTP.");
      }
    } catch (err: any) {
      toast.error(err?.message || "OTP verification failed.");
    }
  };
  // const isFilled = otp.every((val) => val.trim().length > 0);
  // const =
  const handleResend = async (email: any) => {
    if (!email) return;

    try {
      const res: any = await AuthService.DisGenerateLoginOtp(email);
      if (res.message === "Success") {
        toast.success(`OTP sent to ${email}`);
        setTimer(30);
        return res;
      } else {
        toast.error(res?.message || "Failed to send OTP");
      }
    } catch (err: any) {
      toast.error(err?.message || "Failed to send OTP");
      throw err;
    }
  };

  return (
    <div className={styles.OtpVermainDiv}>
      <p className={styles.headDiv}>Verify Email</p>

      <p className={styles.infoText}>
        One Time Password(OTP) has been sent on <span>{email}</span>
      </p>

      {/* <p className={styles.subHeadingOtp}>Enter OTP to verify your email</p> */}

      <form
        className={styles.form}
        autoComplete="off"
        onSubmit={submitForm(onSubmit)}
      >
        {formRenderer(formConfig, formState, register, control)}

        <div className={styles.buttonsSection}>
          <Button
            type="submit"
            className={styles.verifyBtn}
            disabled={isSubmitting || !isValid}
          >
            Verify Email
          </Button>

          <p
            className={`${styles.resendText} ${timer > 0 ? styles.disabled : ""}`}
            onClick={timer > 0 ? undefined : () => handleResend(email)}
          >
            {timer > 0 ? `Resend code in ${timer}s` : "Resend OTP"}
          </p>
        </div>
      </form>
    </div>
  );
};

export default DisLoginOtpVerification;
